import useSWR from 'swr'
import { GetSessionID } from '../Utility/SessionUtility';

/**
 * 権限マスタの型
 */
export interface AuthorityMasterType {
    authority_id: number,
    authority_fame: string,
    authority_name: string,
    select_num: number
}

/**
 * サーバから返ってくるデータの初期状態の型
 * original_statesを削除するために使用
 */
interface AuthorityMasterTempType {
    original_states: any,
    id: number,
    authority_fame: string,
    authority_name: string,
    select_num: number
}

/**
 * 権限マスタ取得Hook
 */
export function useAuthorityMaster() {

    const fetchAddress = `/competition/api/management/tmc020/find?sessionId=${GetSessionID()}`;

    const fetcher = () => fetch(fetchAddress)
    .then(res => {
        return res.json()
    })
    .then(data => {
        //サーバから返ってきたデータを必要なもののみに加工
        let authorityData:Array<AuthorityMasterType> = []
        data?.authority_data?.forEach((item:AuthorityMasterTempType) => {
            authorityData.push({
                authority_id: item.id,
                authority_fame: item.authority_fame,
                authority_name: item.authority_name,
                select_num: item.select_num,
            })
        })

        return authorityData;
    });

    const {data, error, isLoading, mutate} = useSWR(`AuthorityMaster`, fetcher, {revalidateOnFocus:false, revalidateOnReconnect:false});

    return{
        /**
         * 権限マスタ、AuthorityMasterType型のデータ配列
         */
        authorityMaster: data,

        /**
         * ロード中フラグ
         */
        isLoading,

        /**
         * エラーフラグ
         */
        isError: error,

        /**
         * 再取得関数
         */
        mutate,
    }
}